import { api } from './api';

export interface ItemAvaliacao {
  id: string;
  id_turma: string;
  titulo: string;
  descricao?: string;
  valor_maximo: number;
  peso: number;
  ordem: number;
  criado_em: string;
}

export interface Nota {
  id_item_avaliacao: string;
  valor: number | null;
  observacao?: string;
}

export interface MembroComNotas {
  id: string;
  id_militar_grupo: string;
  militar: {
    id_usuario: string;
    nick: string;
    patente?: {
      nome: string;
      abreviacao: string;
    };
  };
  notas: Nota[];
  media: number | null;
}

export interface CreateItemAvaliacaoDTO {
  titulo: string;
  descricao?: string;
  valor_maximo?: number;
  peso?: number;
  ordem?: number;
}

export interface UpdateItemAvaliacaoDTO {
  titulo?: string;
  descricao?: string;
  valor_maximo?: number;
  peso?: number;
  ordem?: number;
}

export interface LancarNotaDTO {
  id_item_avaliacao: string;
  id_membro: string;
  valor: number | null;
  observacao?: string;
}

export const turmasNotasAPI = {
  // ============ ITENS DE AVALIAÇÃO ============

  // Listar itens de avaliação de uma turma
  listarItensAvaliacao: async (idTurma: string): Promise<ItemAvaliacao[]> => {
    const response = await api.get(`/turmas/${idTurma}/itens-avaliacao`);
    return response.data;
  },

  // Criar item de avaliação
  criarItemAvaliacao: async (
    idTurma: string,
    data: CreateItemAvaliacaoDTO
  ): Promise<ItemAvaliacao> => {
    const response = await api.post(`/turmas/${idTurma}/itens-avaliacao`, data);
    return response.data;
  },

  // Atualizar item de avaliação
  atualizarItemAvaliacao: async (
    id: string,
    data: UpdateItemAvaliacaoDTO
  ): Promise<ItemAvaliacao> => {
    const response = await api.put(`/itens-avaliacao/${id}`, data);
    return response.data;
  },

  // Excluir item de avaliação
  excluirItemAvaliacao: async (id: string): Promise<void> => {
    await api.delete(`/itens-avaliacao/${id}`);
  },

  // ============ NOTAS ============

  // Listar notas de uma turma
  listarNotasPorTurma: async (idTurma: string): Promise<MembroComNotas[]> => {
    const response = await api.get(`/turmas/${idTurma}/notas`);
    return response.data;
  },

  // Lançar uma nota
  lancarNota: async (data: LancarNotaDTO): Promise<void> => {
    await api.post('/notas', data);
  },

  // Lançar notas em lote
  lancarNotasEmLote: async (notas: LancarNotaDTO[]): Promise<void> => {
    await api.post('/notas/lote', { notas });
  },

  // Listar notas de um membro
  listarNotasDoMembro: async (idMembro: string): Promise<Nota[]> => {
    const response = await api.get(`/membros/${idMembro}/notas`);
    return response.data;
  },
};
